function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6895 0H15.9775V2.42699C15.3319 2.55924 14.7891 2.84821 14.3713 3.31085C13.883 3.85164 13.6488 4.54122 13.6488 5.34521C13.6488 6.19034 13.8923 6.90121 14.4135 7.42998C14.9035 7.92803 15.6134 8.3189 16.5106 8.62169C17.0415 8.81765 17.3669 9.01504 17.5359 9.19259C17.6892 9.3535 17.7706 9.55578 17.7706 9.8295C17.7706 10.1374 17.679 10.3432 17.5184 10.4925C17.3569 10.6423 17.0968 10.7456 16.6825 10.7456C16.3138 10.7456 16.0389 10.6409 15.8278 10.454C15.6583 10.3039 15.527 10.0129 15.527 9.46702V9.08557L13.3342 9.06653V9.49615C13.3171 10.4803 13.5669 11.2913 14.1434 11.8577C14.6127 12.3188 15.1877 12.6076 15.8542 12.733V15H17.5662V12.7272C18.2375 12.6026 18.803 12.3256 19.2395 11.8783C19.7553 11.3489 20 10.6479 20 9.81682C20 8.97328 19.7599 8.26371 19.2457 7.73654C18.7622 7.24076 18.0555 6.84796 17.1599 6.54131C16.5845 6.31674 16.2464 6.11359 16.0883 5.95029C15.9521 5.81012 15.8719 5.61845 15.8719 5.33219C15.8719 5.00914 15.9554 4.79475 16.0872 4.64689C16.2021 4.51777 16.4096 4.41608 16.7868 4.41608C17.1111 4.41608 17.3228 4.52474 17.4725 4.71406C17.6325 4.91648 17.7331 5.21575 17.7331 5.65595V6.04057H19.932V5.62526C19.9406 4.74766 19.7309 3.99873 19.2678 3.41643C18.8688 2.91432 18.3349 2.59534 17.6895 2.44677V0Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.29189 15.177C1.67984 13.7286 3.53627 13.1567 4.91589 13.744C5.69641 14.0762 6.584 14.3226 7.5 14.3226C8.416 14.3226 9.30359 14.0762 10.0841 13.744C11.4637 13.1567 13.3202 13.7286 13.7081 15.177L14.9157 19.6853C14.9582 19.8441 14.8386 20 14.6742 20H0.325777C0.161404 20 0.0417612 19.8441 0.0842904 19.6853L1.29189 15.177Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 9.5,
  r: 3.5,
  fill: "currentColor"
});

var SvgLoan = function SvgLoan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loan.20f12b06.svg";
export { ForwardRef as ReactComponent };